import type {LeadFormField, UpdateLeadForm} from './models';

// The backend's disabled defaults (what GET returns for an unconfigured
// page) — used to seed the editor before any config exists.
export const defaultLeadFormFields: LeadFormField[] = [
  { key: 'email', label: 'Work email', type: 'email', required: true },
  { key: 'first_name', label: 'First name', type: 'text', required: false },
  { key: 'last_name', label: 'Last name', type: 'text', required: false },
  { key: 'company', label: 'Company', type: 'text', required: false },
  { key: 'message', label: 'What are you looking for?', type: 'textarea', required: false },
];

export const createDefaultLeadForm = (): UpdateLeadForm => ({
  enabled: false,
  destination: 'built_in',
  fields: defaultLeadFormFields.map((field) => ({ ...field })),
  successMessage: "Thanks — we'll be in touch shortly.",
});
